export const QUESTION_TYPES = {
    SINGLE_SELECT_MULTIPLE: 1,
    MULTI_SELECT_MULTIPLE: 2,
    OPEN_ENDED_TEXT: 3,
    RATE_ITEMS_ON_A_SCALE: 4,
    BREAK_PAGE: 5,
    COLLECT_PERSONAL_INFORMATION: 7,
    TEXT_BLOCK: 9,
    OPEN_ENDED_SINGLE: 13,
    PULL_DOWN: 14,
    DATE_QUESTION: 15,
    RATING_ITEMS: 16,
    SINGLE_IMAGES_SELECT_MULTIPLE: 17,
    TERMS_AND_CONDITIONS: 19,
    DEPENDENT_PULLDOWN: 20
}

export const questionTypesMixin = {
    data() {
        return {
            QUESTION_TYPES
        }
    }
}
